var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

import Icon from './wrappers/ReUpIcon';

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var PlatformConstants = require('./constants/PlatformConstants');
var ReUpField = require('./ReUpField');

// var CardIO, { CardIOConstants } = require('react-native-card.io')
// import CardIO, { CardIOConstants } from 'react-native-card.io';
var CardIO = require('./CardIO.js');
var ReUpCreditCardInput = require('./ReUpCreditCardInput.js');

var MAX_CREDIT = parseFloat(10);
var lastSelectedAmount = null;

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
  MKRadioButton,
} = MK;

var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var FeedCard = require('./feedCard.js');
var ProgressOverlay = require('./ProgressOverlay.js');

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  NativeAppEventEmitter,
  Platform,
  NativeModules,
  StyleSheet,
  Keyboard,
} = ReactNative;

var RNPayPalManager = NativeModules.RNPayPalManager;

import Camera from './wrappers/react-native-camera-wrapper';

function cardTypeForNumber(cardNumber)
{
  if (cardNumber.length < 2) return -1;

  var range = parseInt(cardNumber.substring(0, 2));

  if (range >= 40 && range <= 49) {
      return 1;//PKCardTypeVisa;
  } else if (range >= 50 && range <= 59) {
      return 2;//PKCardTypeMasterCard;
  } else if (range == 34 || range == 37) {
      return 3;//PKCardTypeAmex;
  } else if (range == 60 || range == 62 || range == 64 || range == 65) {
      return 4;//PKCardTypeDiscover;
  } else if (range == 35) {
      return 5;//PKCardTypeJCB;
  } else if (range == 30 || range == 36 || range == 38 || range == 39) {
      return 6;//PKCardTypeDinersClub;
  } else {
    return -1;
  }
}

function cardNumberIsValidLength(cardNumber)
{
  var cardType = cardTypeForNumber(cardNumber);

  return cardNumber.length >= validLengthForCardType(cardType);
}

function validLengthForCardType(cardType)
{
  if( cardType == 3 ) // amex
  {
    return 15;
  }
  else if( cardType == 6 ) // PKCardTypeDinersClub
  {
    return 14;
  }
  else
  {
    return 16;
  }
}

function validLengthCVCForCardType(cardType)
{
  if( cardType == 3 )
  {
    return 4; // amex
  }

  return 3;
}

function cardTypeFromName(cardTypeName)
{
  var lowerName = cardTypeName.toLowerCase();
  if( lowerName == "visa" ) return 1;
  if( lowerName == "mastercard" || lowerName == "mc" ) return 2;
  if( lowerName == "american express" || lowerName == "americanexpress" || lowerName == "amex" ) return 3;

  return -1;
}

function iconNameForCardType(cardType)
{
  if (cardType == 1) {
      return "cc-visa";//PKCardTypeVisa;
  } else if (cardType == 2) {
      return "cc-mastercard";//PKCardTypeMasterCard;
  } else if (cardType == 3) {
      return "cc-amex";//PKCardTypeAmex;
  } else if (cardType == 4) {
      return "cc-discover";//PKCardTypeDiscover;
  } else if (cardType == 5) {
      return "cc-jcb";//PKCardTypeJCB;
  } else if (cardType == 6) {
      return "cc-diners-club";//PKCardTypeDinersClub;
  } else {
    return "credit-card";
  }
}

function removeSpaces(str)
{
  return str.replace(/\s+/g, '');
}

function isValidPostalCode(postalCode, countryCode)
{
  var postalCodeRegex = "";
  switch (countryCode) {
    case "US":
      postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
      break;
    case "CA":
      postalCodeRegex = /^(([A-Z]|[a-z])[0-9]([A-Z]|[a-z]))\s*([0-9]([A-Z]|[a-z])[0-9])$/;
      break;
    default:
      postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
  }
  return postalCodeRegex.test(postalCode);
}

function isPossiblyPostalCode(code)
{
  if( code.length < 2 ) return false;
  var firstChar = code.substr(0,1);

  return firstChar.match(/[a-z]|[A-Z]/i);
}

var PaymentTypes = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras:{shouldPopAfterSelectingPaymentType:false}
    }
  },

  getInitialState : function()
  {
    if( !this.props.appManager.isLoggedIn() )
    {
      return {
        layout : this.props.initialLayout,
        creditCardPresent : false,
        newCardValid : false,
        proposedCardNumber : "",
        proposedYearNumber : "",
        proposedMonthNumber : "",
        proposedCVVNumber : "",
        user:null,
        sources:[],
        hasStripe:false,
        hasBeanStream:false,
        hasPayPal:false,
        cameraView:null,
        errorMessage: this.props.appManager.getLocalizationManager().localizedStringForKey("CARD_ERROR"),
        cardViewLoaded:false, // only used for stripe + iOS for now,  stripe elements
      }
    }

    return this.getUpdatedState();
  },

  getUpdatedState : function()
  {
    var user = this.props.appManager.currentUser();
    var sources = this.props.appManager.getPaymentInfo();

    var hasPayPal = user != null && typeof user[ModelConstants.PayPal_ClientID] !== 'undefined' && user[ModelConstants.PayPal_ClientID].length > 0;
    var hasStripe = user != null && typeof user[ModelConstants.StripeKey] !== 'undefined' && user[ModelConstants.StripeKey].length > 0;

    var gateway = user != null && typeof user[ModelConstants.CC_Gateway_Primary] !== 'undefined' ? user[ModelConstants.CC_Gateway_Primary] : "stripecc";
    var hasBeanStream = gateway == "beancc";
    hasStripe = hasStripe && (gateway == "stripecc");

    return {
      layout : this.state != null && typeof this.state.layout !== 'undefined' ? this.state.layout : this.props.initialLayout,
      creditCardPresent : user != null && user[ModelConstants.LastFour].length > 0,
      newCardValid : false,
      proposedCardNumber : "",
      proposedYearNumber : "",
      proposedMonthNumber : "",
      proposedCVVNumber : "",
      user:user,
      sources:sources,
      hasStripe:hasStripe,
      hasBeanStream:hasBeanStream,
      hasPayPal:hasPayPal,
      payPalClientID:user[ModelConstants.PayPal_ClientID],
      payPalEnvironment:user[ModelConstants.PayPal_Environment],
      cameraView:null,
      shouldShowSpinner: false,
      spinnerText: this.props.appManager.getLocalizationManager().localizedStringForKey("CHECKING_HUD"),
      errorMessage: this.props.appManager.getLocalizationManager().localizedStringForKey("CARD_ERROR"),
      numberOfSuccessfulCardAdds: 0,
    }
  },

  updateState : function()
  {
    this.setState(this.getUpdatedState());
  },

  focus: function()
  {
    var thisThing = this;
    this.updateState();
    setTimeout(()=>
    {
      thisThing._newCardNumberField.focus();
    }, 200)
  },

  _hasCamera : false,
  _cardIODidScanCardListener : null,
  _payPalDidSucceedListener : null,
  _payPalDidFailListener : null,
  componentDidMount : function()
  {
    var thisThing = this;
    var appActions = thisThing.props.appActions;
    var appManager = thisThing.props.appManager;
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

    thisThing._hasCamera = true;
    if( Platform.OS == 'ios' )
    {
      this._cardIODidScanCardListener = NativeAppEventEmitter.addListener(
        'cardIODidScanCard',
        (evt) =>
        {
          if( evt.cardInfo.cardNumber )
          {
            thisThing.newCardTextChange(evt.cardInfo.cardNumber + "");
          }
          if( evt.cardInfo.expiryMonth )
          {
            thisThing.newCardMonthTextChange(evt.cardInfo.expiryMonth + "");
          }
          if( evt.cardInfo.expiryYear )
          {
            evt.cardInfo.expiryYear = evt.cardInfo.expiryYear%100;
            thisThing.newCardYearTextChange(evt.cardInfo.expiryYear + "");
          }
          if( evt.cardInfo.cvv )
          {
            thisThing.newCardSecurityTextChange(evt.cardInfo.cvv + "");
          }
          thisThing.showSetCard();
        });
      this._payPalDidSucceedListener = NativeAppEventEmitter.addListener(
        'payPalDidSucceed',
        (evt) =>
        {
          var authorizationToken = evt.response.code;
          NetworkManager.setPayPal( thisThing.props.appManager, authorizationToken, "connected", function(data)
          {
            var paymentInfo = JSON.parse(data[0]);
            appManager.setPaymentInfo(data[0], function(user)
            {
              RNPayPalManager.payPalDidConnect();
              thisThing.setState({sources:paymentInfo});
            })
          }, function(data)
          {
            RNPayPalManager.payPalDidConnect();
            if ( !useInterstitialFlow )
            {
              appActions.showLocalizedAlert("PAYPAL_CONNECT_FAILURE_ALERT_TITLE", "PAYPAL_CONNECT_FAILURE_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
                {
                appActions.hideAlert();
              }], function(){})
            }
            else
            {
              thisThing.setState({shouldShowSpinner: false, showError: false});
              thisThing.props.extras.showNetworkErrorAlert();
            }
          }, function(data)
          {
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(false);
              appActions.showNetworkErrorAlert(thisThing.showSetCard, function(){})
            }
            else
            {
              thisThing.setState({shouldShowSpinner: false, showError: false});
              thisThing.props.extras.showNetworkErrorAlert();
            }
            RNPayPalManager.payPalDidConnect();
          })
        });
      this._payPalDidFailListener = NativeAppEventEmitter.addListener(
        'payPalDidFail',
        (evt) =>
        {
        });
    }
    else
    {
      if( DeviceEventEmitter )
      {
        this._cardIODidScanCardListener = DeviceEventEmitter.addListener('cardIODidScanCard', function(evt)
        {
          if( evt.cardInfo.cardNumber )
          {
            thisThing.newCardTextChange(evt.cardInfo.cardNumber + "");
          }
          if( evt.cardInfo.expiryMonth )
          {
            thisThing.newCardMonthTextChange(evt.cardInfo.expiryMonth + "");
          }
          if( evt.cardInfo.expiryYear )
          {
            evt.cardInfo.expiryYear = evt.cardInfo.expiryYear%100;
            thisThing.newCardYearTextChange(evt.cardInfo.expiryYear + "");
          }
          if( evt.cardInfo.cvv )
          {
            thisThing.newCardSecurityTextChange(evt.cardInfo.cvv + "");
          }
          thisThing.showSetCard();
        });
        this._payPalDidSucceedListener = DeviceEventEmitter.addListener(
        'payPalDidSucceed',
        (evt) =>
        {
          var authorizationToken = evt.response.code;
          NetworkManager.setPayPal( thisThing.props.appManager, authorizationToken, "connected", function(data)
          {
            var paymentInfo = JSON.parse(data[0]);
            appManager.setPaymentInfo(data[0], function(user)
            {
              RNPayPalManager.payPalDidConnect();
              thisThing.setState({sources:paymentInfo});
            })
          }, function(data)
          {
            RNPayPalManager.payPalDidConnect();
            if ( !useInterstitialFlow )
            {
              appActions.showLocalizedAlert("PAYPAL_CONNECT_FAILURE_ALERT_TITLE", "PAYPAL_CONNECT_FAILURE_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
                {
                appActions.hideAlert();
              }], function(){})
            }
            else
            {
              thisThing.setState({shouldShowSpinner: false, showError: false});
              thisThing.props.extras.showNetworkErrorAlert();
            }
          }, function(data)
          {
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(false);
              appActions.showNetworkErrorAlert(thisThing.showSetCard, function(){})
            }
            else
            {
              thisThing.setState({shouldShowSpinner: false, showError: false});
              thisThing.props.extras.showNetworkErrorAlert();
            }
            RNPayPalManager.payPalDidConnect();
          })
        });
        this._payPalDidFailListener = DeviceEventEmitter.addListener(
        'payPalDidFail',
        (evt) =>
        {
        });
      }
    }

    var appManager = this.props.appManager;
    this.props.appManager.getDataType("Transactions",function(transactions)
    {
      if( typeof transactions === 'undefined' || transactions.length <= 0 ) return;

      var sortedTransactions = transactions.sort(function(a,b)
      {
        return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
      })
      var initialValue = null;
      for( var i = 0; i < sortedTransactions.length; i++ )
      {
        var transaction = sortedTransactions[i];
        if( typeof transaction.Credit !== 'undefined' && transaction.Credit != null && parseInt(transaction.Credit) > 0 )
        {
          initialValue = parseInt(transaction.Credit);
          break;
        }
      }
      if( initialValue != null )
      {
        if( thisThing.refs.PriceChooserView ) thisThing.refs.PriceChooserView.setAmount(initialValue);
      }
    });
  },

  componentWillUnmount : function()
  {
    if( this._cardIODidScanCardListener != null ) this._cardIODidScanCardListener.remove();
    if( this._payPalDidSucceedListener != null ) this._payPalDidSucceedListener.remove();
    if( this._payPalDidFailListener != null ) this._payPalDidFailListener.remove();
  },

  _newCardNumber : "",
  newCardTextChange : function(text)
  {
    var didAddText = text.length > this._newCardNumber.length;
    var noSpaces = removeSpaces(text);
    var moddedText = noSpaces.substring(0,4);

    if( noSpaces.length > 4 )
    {
      moddedText += " " + noSpaces.substring(4,8);
    }
    if( noSpaces.length > 8 )
    {
      moddedText += " " + noSpaces.substring(8,12);
    }
    if( noSpaces.length > 12 )
    {
      moddedText += " " + noSpaces.substring(12,16);
    }
    if( didAddText && (noSpaces.length % 4) == 0 )
    {
      moddedText += " "
    }
    moddedText = moddedText.substring(0,19);
    this._newCardNumber = moddedText;

    var cardType = cardTypeForNumber(moddedText);
    var maxLengthCVC = validLengthCVCForCardType(cardType);
    if( this._newCardSecurityMaxLength != maxLengthCVC )
    {
      this._newCardSecurityMaxLength = maxLengthCVC;
    }

    if( moddedText != text )
    {
      this._newCardNumber = moddedText;
      this.showSetCard();
    }
    else
    {
      this._newCardNumber = text;
      this.showSetCard();
    }
    var cardType = cardTypeForNumber(this._newCardNumber);
    var maxLength = validLengthForCardType(cardType);
    if( didAddText && maxLength > 0 && removeSpaces(this._newCardNumber).length == maxLength )
    {
      if( typeof this._newCardMonthField.focus !== 'undefined' ) this._newCardMonthField.focus();
    }
  },

  _newCardSecurity : "",
  _newCardSecurityMaxLength : 3,
  newCardSecurityTextChange : function(text)
  {
    var cardType = cardTypeForNumber(this._newCardNumber);
    var maxLengthCVC = validLengthCVCForCardType(cardType);

    var didAddText = text.length > this._newCardSecurity.length;
    this._newCardSecurity = text;
    if( didAddText && text.length >= maxLengthCVC )
    {
      if( this.props.appManager.userRequiresPostalCode() ) this._newCardPostalCodeField.focus();
      else this.setCardFinished();
    }

    if( this._newCardSecurityMaxLength != maxLengthCVC )
    {
      this._newCardSecurityMaxLength = maxLengthCVC;
      this.showSetCard()
    }
  },

  _newCardPostalCode : "",
  _newCardPostalCodeMaxLength : 7,
  newCardPostalCodeTextChange : function(text)
  {
    var moddedText = text;
    var didAddText = text.length > this._newCardPostalCode.length;
    var noSpaces = removeSpaces(text);

    if( isPossiblyPostalCode(noSpaces) )
    {
      if( noSpaces.length > 3 )
      {
        moddedText = noSpaces.substring(0,3) + " " + noSpaces.substring(3,noSpaces.length);
      }
      else if( noSpaces.length > 2 && !didAddText )
      {
        moddedText = noSpaces.substring(0,noSpaces.length);
      }
      else if( noSpaces.length > 2 && didAddText )
      {
        moddedText = noSpaces.substring(0,noSpaces.length) + " ";
      }
    }

    var shouldReShow = moddedText != text;
    this._newCardPostalCode = moddedText;

    var postalError = !(isValidPostalCode(moddedText, "CA") || isValidPostalCode(moddedText, "US"));
    shouldReShow |= postalError != this._postalError;
    this._postalError = postalError;

    var maxLength = isPossiblyPostalCode(moddedText) ? 7 : 5;
    shouldReShow |= maxLength != this._newCardPostalCodeMaxLength;
    this._newCardPostalCodeMaxLength = maxLength;

    if( didAddText && (moddedText.length >= maxLength))
    {
      this.setCardFinished();
    }
    else if( shouldReShow )
    {
      this.showSetCard();
    }
  },

  _newCardMonth : "",
  newCardMonthTextChange : function(text)
  {
    if( (text.length > this._newCardMonth.length) &&
        ( ( text.length == 1 && text != "1" && text != "0") ||
          ( text.length == 2 && parseInt(text) < 13) ) )
    {
      this._newCardYearField.focus();
    }
    this._newCardMonth =  text;
    this.showSetCard();
  },

  _newCardYear : "",
  newCardYearTextChange : function(text)
  {
    if( (text.length > this._newCardYear.length) &&
        ( ( text.length == 2 ) ) )
    {
      this._newCardSecurityField.focus();
    }
    this._newCardYear = text.substring(0,2);
  },

  saveCard : function(token, lastFour, cardMonth, cardYear, cardType)
  {
    var addCredit = this;
    var user = this.props.appManager.currentUser();
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var appManager = this.props.appManager;
    var checkingHUD = locManager.localizedStringForKey('CHECKING_HUD');
    var savingHUD = locManager.localizedStringForKey('SAVING_HUD');
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

    if ( !useInterstitialFlow )
    {
      appActions.setSpinnerShown(true, savingHUD);
    }
    else
    {
      addCredit.setState({spinnerText: savingHUD})
    }
    NetworkManager.setCreditCard( addCredit.props.appManager, token, lastFour, cardMonth, cardYear, cardType, function(data)
    {
      var paymentInfo = JSON.parse(data[0]);
      appManager.setPaymentInfo(data[0], function(user)
      {
        addCredit.setState({numberOfSuccessfulCardAdds:addCredit.state.numberOfSuccessfulCardAdds+1});
        if ( !useInterstitialFlow )
        {
          appActions.setSpinnerShown(false);
          addCredit.setState({sources:paymentInfo});
          var successTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_TITLE", "Success!");
          var successBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_BODY", "This card is now associated with your account.");
          var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
          appActions.showAlert(successTitle,successBody,[successOkay],[function()
          {
            appActions.hideAlert();
            if( paymentInfo.length <= 1 ) appActions.requestPop(true);
          }], function(){})
        }
        else
        {
          addCredit.setState({shouldShowSpinner: false});
          addCredit.props.extras.paymentTypesDidFinish();
        }
      })
    }, function()
    {
      var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
      var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
      var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
      if ( !useInterstitialFlow )
      {
        appActions.setSpinnerShown(false);
        appActions.showAlert(title,body,[okay],[addCredit.showSetCard], function(){})
      }
      else
      {
        addCredit.setState({shouldShowSpinner: false, showError: true, errorMessage: body})
      }
    }, function()
    {
      if ( !useInterstitialFlow )
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(addCredit.showSetCard, function(){})
      }
      else
      {
        addCredit.setState({shouldShowSpinner: false, showError: false});
        addCredit.props.extras.showNetworkErrorAlert();
      }
    })
  },

  _cardError : false,
  _monthError : false,
  _yearError : false,
  _cvvError : false,
  _postalError : false,
  setCardFinished : function()
  {
    Keyboard.dismiss();
    var addCredit = this;
    this._cardError = false;
    this._monthError = false;
    this._YearError = false;
    this._cvvError = false;
    this._postalError = false;
    if( !cardNumberIsValidLength(removeSpaces(this._newCardNumber)) )
    {
      this._cardError = true;
    }
    if( this._newCardMonth.length < 1 || parseInt(this._newCardMonth) < 0 || parseInt(this._newCardMonth) > 12 )
    {
      this._monthError = true;
    }
    if( this._newCardYear.length <= 0 )
    {
      this._yearError = true;
    }
    if( this._newCardSecurity.length < 3)
    {
      this._cvvError = true;
    }
    if( this.props.appManager.userRequiresPostalCode() && !(isValidPostalCode(this._newCardPostalCode, "CA") || isValidPostalCode(this._newCardPostalCode, "US")) )
    {
      this._postalError = true;
    }

    if( this._cardError || this._monthError || this._YearError || this._cvvError || this._postalError )
    {
      this._setCardShown = false;
      this.showSetCard();
    }
    else
    {
      var addCredit = this;
      var user = this.props.appManager.currentUser();
      var appActions = this.props.appActions;
      var locManager = this.props.appManager.getLocalizationManager();
      var appManager = this.props.appManager;
      var checkingHUD = locManager.localizedStringForKey('CHECKING_HUD');
      var savingHUD = locManager.localizedStringForKey('SAVING_HUD');
      var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

      if ( !useInterstitialFlow )
      {
        appActions.setCustomAlertShown(false);
        appActions.setSpinnerShown(true, checkingHUD);
      }
      else
      {
        this.setState({shouldShowSpinner: true, spinnerText: checkingHUD})
        Keyboard.dismiss();
      }

      if( this.state.hasStripe )
      {
        NetworkManager.stripeFetchToken(user[ModelConstants.StripeKey], removeSpaces(this._newCardNumber), this._newCardMonth, this._newCardYear, this._newCardSecurity, appManager.userRequiresPostalCode() ? removeSpaces(this._newCardPostalCode) : null, function(data)
        {
          console.log("stripeFetchToken", data)
          if( typeof data.error !== 'undefined' )
          {
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(false);
            }
            else
            {
              addCredit.setState({shouldShowSpinner: false})
            }
            if( data.error.type == "invalid_request_error" )
            {
              alert("Vendor's stripe account is not connected.");
            }
            else if( data.error.code == "card_declined" || data.error.code == "number" || data.error.code == "incorrect_number" )
            {
              addCredit._cardError = true;
            }
            else if( data.error.code == "month_error" || data.error.code == "invalid_expiry_month" )
            {
              addCredit._monthError = true;
            }
            else if( data.error.code == "exp_year" || data.error.code == "invalid_expiry_year" )
            {
              addCredit._yearError = true;
            }
            else if( data.error.code == "cvv_error" || data.error.code == "invalid_cvv" || data.error.code == "invalid_cvc" )
            {
              addCredit._cvvError = true;
            }
            else if( data.error.code == "incorrect_zip" )
            {
              addCredit._postalError = true;
            }
            addCredit.showSetCard();
          }
          else
          {
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(true, savingHUD);
            }
            else
            {
              addCredit.setState({spinnerText: 'Saving Card...'})
            }
            var lastFour = addCredit._newCardNumber.substring(addCredit._newCardNumber.length-4,addCredit._newCardNumber.length);
            var cardType = cardTypeForNumber(addCredit._newCardNumber);
            NetworkManager.setCreditCard( addCredit.props.appManager, data.id, lastFour, addCredit._newCardMonth, addCredit._newCardYear, cardType, function(data)
            {
              var paymentInfo = JSON.parse(data[0]);
              appManager.setPaymentInfo(data[0], function(user)
              {
                addCredit.setCard();
                if ( !useInterstitialFlow )
                {
                  appActions.setSpinnerShown(false);
                  addCredit.setState({sources:paymentInfo});
                  var successTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_TITLE", "Success!");
                  var successBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_BODY", "This card is now associated with your account.");
                  var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
                  appActions.showAlert(successTitle,successBody,[successOkay],[function()
                  {
                    appActions.hideAlert();
                    if( paymentInfo.length <= 1 ) appActions.requestPop(true);
                  }], function(){})
                }
                else
                {
                  addCredit.setState({shouldShowSpinner: false});
                  addCredit.props.extras.paymentTypesDidFinish();
                }
              })
            }, function()
            {
              var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
              var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
              var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
              if ( !useInterstitialFlow )
              {
                appActions.setSpinnerShown(false);
                appActions.showAlert(title,body,[okay],[addCredit.showSetCard], function(){})
              }
              else
              {
                addCredit.setState({shouldShowSpinner: false, showError: true, errorMessage: body})
              }
            }, function()
            {
              if ( !useInterstitialFlow )
              {
                appActions.setSpinnerShown(false);
                appActions.showNetworkErrorAlert(addCredit.showSetCard, function(){})
              }
              else
              {
                addCredit.setState({shouldShowSpinner: false, showError: false});
                addCredit.props.extras.showNetworkErrorAlert();
              }
            })
          }
        }, function(data)
        {
          if ( !useInterstitialFlow )
          {
            appActions.setSpinnerShown(false);
            appActions.showNetworkErrorAlert(addCredit.showSetCard, addCredit.showSetCard)
          }
          else
          {
            addCredit.setState({shouldShowSpinner: false, showError: false});
            addCredit.props.extras.showNetworkErrorAlert();
          }
        });
      }
      else if( this.state.hasBeanStream )
      {
        NetworkManager.beanStreamFetchToken(removeSpaces(this._newCardNumber), this._newCardMonth, this._newCardYear, this._newCardSecurity, function(data)
        {
          if( typeof data.token === 'undefined' )
          {
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(false);
              appActions.showLocalizedAlert("CARD_PAYMENT_FAIL_ALERT_TITLE", "CARD_PAYMENT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"][addCredit.showSetCard], function(){});
            }
            else
            {
              addCredit.setState({shouldShowSpinner: false, showError: true})
            }
          }
          else
          {
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(true, savingHUD);
            }
            else
            {
              var savingCardSpinnerStr = locManager.localizedStringForKey("SAVING_CARD_SPINNER");
              addCredit.setState({spinnerText: savingCardSpinnerStr})
            }
            var lastFour = addCredit._newCardNumber.substring(addCredit._newCardNumber.length-4,addCredit._newCardNumber.length);
            var cardType = cardTypeForNumber(addCredit._newCardNumber);
            NetworkManager.setCreditCard( addCredit.props.appManager, data.token, lastFour, addCredit._newCardMonth, addCredit._newCardYear, cardType, function(data)
            {
              var paymentInfo = JSON.parse(data[0]);
              appManager.setPaymentInfo(data[0], function(user)
              {
                if ( !useInterstitialFlow )
                {
                  appActions.setSpinnerShown(false);
                  addCredit.setState({sources:paymentInfo});
                  var successTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_TITLE", "Success!");
                  var successBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_BODY", "This card is now associated with your account.");
                  var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
                  appActions.showAlert(successTitle,successBody,[successOkay],[function()
                  {
                    appActions.hideAlert();
                    if( paymentInfo.length <= 1 ) appActions.requestPop(true);
                  }], function(){})
                }
                else
                {
                  addCredit.setState({shouldShowSpinner: false});
                  addCredit.props.extras.paymentTypesDidFinish();
                }
              })
            }, function()
            {
              if ( !useInterstitialFlow )
              {
                appActions.setSpinnerShown(false);
              }
              else
              {
                addCredit.setState({shouldShowSpinner: false})
              }

              if( data.code == -51 )
              {
                var title = locManager.localizedStringForKey("CREDIT_CARD_EXISTS_ERROR_ALERT_TITLE");
                var body = locManager.localizedStringForKey("CREDIT_CARD_EXISTS_ERROR_ALERT_BODY");
                var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");

                if ( !useInterstitialFlow )
                {
                  appActions.showAlert(title,body,[okay],[addCredit.showSetCard], function(){})
                }
                else
                {
                  addCredit.setState({shouldShowSpinner: false, showError: true, errorMessage: body})
                }
              }
              else if( data.code == -54 )
              {
                var title = locManager.localizedStringForKey("MAX_CARDS_ERROR_ALERT_TITLE");
                var body = locManager.localizedStringForKey("MAX_CARDS_ERROR_ALERT_BODY");
                var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");

                if ( !useInterstitialFlow )
                {
                  appActions.showAlert(title,body,[okay],[appActions.hideAlert()], function(){})
                }
                else
                {
                  addCredit.setState({shouldShowSpinner: false, showError: true, errorMessage: body})
                }
              }
              else
              {
                var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
                var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
                var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");

                if ( !useInterstitialFlow )
                {
                  appActions.showAlert(title,body,[okay],[addCredit.showSetCard], function(){})
                }
                else
                {
                  addCredit.setState({shouldShowSpinner: false, showError: true, errorMessage: body})
                }
              }
            }, function()
            {
              if ( !useInterstitialFlow )
              {
                appActions.setSpinnerShown(false);
                appActions.showNetworkErrorAlert(addCredit.showSetCard, function(){})
              }
              else
              {
                addCredit.setState({shouldShowSpinner: false, showError: false});
                addCredit.props.extras.showNetworkErrorAlert();
              }
            })
          }
        }, function(data)
        {
          if ( !useInterstitialFlow )
          {
            appActions.setSpinnerShown(false);
            appActions.showNetworkErrorAlert(addCredit.showSetCard, addCredit.showSetCard)
          }
          else
          {
            addCredit.setState({shouldShowSpinner: false, showError: false});
            addCredit.props.extras.showNetworkErrorAlert();
          }
        });
      }
    }
  },

  _newCardNumberField : null,
  _newCardMonthField : null,
  _newCardYearField : null,
  _newCardSecurityField : null,
  setCard : function()
  {
    // reset any old new card info
    this._newCardSecurity = "";
    this._newCardMonth = "";
    this._newCardYear = "";
    this._newCardNumber = "";
    this._newCardPostalCode = "";
    this._cardError = false;
    this._monthError = false;
    this._yearError = false;
    this._cvvError = false;
    this._postalError = false;

    this.showSetCard();
  },

  _errorCount: 0,
  getSetCardView : function()
  {
    var user = this.props.appManager.currentUser();

    var thisThing = this;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var setCreditCardLabel = locManager.localizedStringForKey("ADD_CREDIT_CARD_BUTTON");
    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

    if( this.state.hasStripe && Platform.OS == 'ios' )
    {
      return <View style={{flex:1, alignSelf:'stretch', flexDirection:'column', paddingBottom:useInterstitialFlow ? 0 : 10}}>
        <ReUpCreditCardInput
          ref={ref => this._cardInput = ref}
          key={"stripecreditinput"+this.state.numberOfSuccessfulCardAdds}
          style={{height:100, flex:1}}
          appManager={this.props.appManager}
          onLoad={()=>this.setState({cardViewLoaded:true})}
          onError={()=>
          {
            var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
            var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
            var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(false);
              appActions.showAlert(title,body,[okay],[appActions.hideAlert], appActions.hideAlert)
            }
            else
            {
              addCredit.setState({shouldShowSpinner: false, showError: true, errorMessage: body})
            }
          }}/>
        <ReUpButton appManager={this.props.appManager} text={setCreditCardLabel} style={{marginHorizontal:10, opacity:this.state.cardViewLoaded ? 1 : .4}} onPress={()=>
          {
            if( !thisThing._cardInput.hasLoaded() ) return;

            if ( !useInterstitialFlow )
            {
              appActions.setSpinnerShown(true, processingHUD);
            }
            else
            {
              thisThing.setState({shouldShowSpinner: true, spinnerText: processingHUD})
            }
            thisThing._cardInput.retrieveCardInfo((cardInfo)=>
            {
              thisThing.saveCard(cardInfo.token, cardInfo.last4, cardInfo.exp_month, cardInfo.exp_year, cardTypeFromName(cardInfo.cardType))
              thisThing._cardInfo = cardInfo;
            }, ()=>
            {
              // if ( !useInterstitialFlow )
              // {
              //   appActions.setSpinnerShown(false);
              // }
              // else
              // {
              //   thisThing.setState({shouldShowSpinner: false, spinnerText: ""})
              // }
              // Leaving this blank because elements seems to take care of the error
              //
              var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
              var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
              var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
              if ( !useInterstitialFlow )
              {
                appActions.setSpinnerShown(false);
                appActions.showAlert(title,body,[okay],[()=>
                {
                  appActions.hideAlert();
                  thisThing.showSetCard();
                }], function(){})
              }
              else
              {
                thisThing.setState({shouldShowSpinner: false, spinnerText: ""})
                thisThing._errorCount++;
                if( thisThing._errorCount > 2 )
                {
                  thisThing.props.extras.interstitialDidFinish((appActions)=>
                  {
                    appActions.showAlert(title,body,[okay],[appActions.hideAlert], function(){})
                  })
                }
              }
            })
          }}
          />
        </View>;
    }
    else if( this.state.hasStripe || this.state.hasBeanStream )
    {
      var addCredit = this;
      var appManager = this.props.appManager;
      var locManager = this.props.appManager.getLocalizationManager();
      var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

      var setCreditCardLabel = locManager.localizedStringForKey("ADD_CREDIT_CARD_BUTTON");

      var generalColor = 'white';//appManager.getColorForKey("GeneralColor");
      var generalTitleColor = 'black';//appManager.getColorForKey("GeneralTitleColor");
      var bannerColor = 'black';//appManager.getColorForKey("FeedCardBannerColor");

      var cardType = cardTypeForNumber(this._newCardNumber);
      var maxLength = validLengthForCardType(cardType);
      var errorMessage = this.state.errorMessage;
      if( maxLength < 0 ) maxLength = 16;
      maxLength += 3;

      var cardNumberError = this._newCardNumber.length >= 4 ? cardType < 0 : false;

      var _newCardNumberField = <ReUpField
        key="card"
        ref={(a) => {
          addCredit._newCardNumberField = a;
          if ( !addCredit._setCardShown && addCredit._newCardNumberField && addCredit._newCardNumberField != null && !useInterstitialFlow )
          {
            setTimeout(()=>
            {
              if( typeof addCredit._newCardNumberField !== 'undefined' && addCredit._newCardNumberField != null )
              {
                addCredit._newCardNumberField.focus();
                addCredit._setCardShown = true;                
              }
            }, 2000);
          }
        }}
        value={this._newCardNumber}
        underlineColorAndroid='transparent'
        keyboardType={"phone-pad"}
        appManager={appManager}
        onChangeText={this.newCardTextChange.bind(this)}
        tintColor={this._cardError || cardNumberError ? 'red' : bannerColor}
        highlightColor={this._cardError || cardNumberError ? 'red' : bannerColor}
        textInputStyle={{color: generalTitleColor}}
        placeholder={locManager.localizedStringForKey("CARD_NUMBER_PLACEHOLDER")}
        onSubmitEditing={() => this._newCardMonthField.focus()}
        maxLength={maxLength}
        style={{flex:1}}/>;

      var isMonthError = parseInt(this._newCardMonth) > 12;
      var _newCardMonthField = <ReUpField
        key="month"
        ref={(a) => addCredit._newCardMonthField = a}
        underlineColorAndroid='transparent'
        maxLength={2}
        appManager={appManager}
        defaultValue={this._newCardMonth}
        keyboardType={"phone-pad"}
        onChangeText={this.newCardMonthTextChange.bind(this)}
        tintColor={this._monthError || isMonthError ? 'red' : bannerColor}
        highlightColor={this._monthError || isMonthError ? 'red' : bannerColor}
        textInputStyle={{color: generalTitleColor}}
       placeholder={locManager.localizedStringForKey("MONTH_MONTH_SHORT_DATE_PLACEHOLDER", "MM")} 
        onSubmitEditing={() => this._newCardYearField.focus()}
        style={{width:50, alignSelf:'stretch'}}/>;

      var _newCardYearField = <ReUpField
        key="Year"
        ref={(a) => addCredit._newCardYearField = a}
        underlineColorAndroid='transparent'
        maxLength={2}
        appManager={appManager}
        defaultValue={this._newCardYear}
        keyboardType={"phone-pad"}
        onChangeText={this.newCardYearTextChange.bind(this)}
        tintColor={this._yearError ? 'red' : bannerColor}
        highlightColor={this._yearError ? 'red' : bannerColor}
        textInputStyle={{color: generalTitleColor}}
        placeholder={locManager.localizedStringForKey("YEAR_YEAR_SHORT_DATE_PLACEHOLDER", "YY")} 
        onSubmitEditing={() => this._newCardSecurityField.focus()}
        style={{width:50}}/>;

      var _newCardSecurityField = <ReUpField
        key="CVV"
        ref={(a) => addCredit._newCardSecurityField = a}
        underlineColorAndroid='transparent'
        maxLength={this._newCardSecurityMaxLength}
        appManager={appManager}
        defaultValue={this._newCardSecurity}
        keyboardType={"phone-pad"}
        onChangeText={this.newCardSecurityTextChange.bind(this)}
        tintColor={this._cvvError ? 'red' : bannerColor}
        highlightColor={this._cvvError ? 'red' : bannerColor}
        textInputStyle={{color: generalTitleColor}}
        placeholder={locManager.localizedStringForKey("CREDIT_CARD_CSV_PLACEHOLDER", "CVV")} 
        style={{width:60}}/>;

      var _newCardPostalCodeField = null;
      if( appManager.userRequiresPostalCode() )
      {
        _newCardPostalCodeField = <ReUpField
          key="POSTAL"
          ref={(a) => addCredit._newCardPostalCodeField = a}
          underlineColorAndroid='transparent'
          maxLength={this._newCardPostalCodeMaxLength}
          appManager={appManager}
          defaultValue={this._newCardPostalCode}
          onChangeText={this.newCardPostalCodeTextChange.bind(this)}
          tintColor={this._postalError ? 'red' : bannerColor}
          highlightColor={this._postalError ? 'red' : bannerColor}
          textInputStyle={{color: generalTitleColor}}
          placeholder={locManager.localizedStringForKey("POSTAL_ZIP_CODE","postal/zip Code")}
          style={{width:120}}/>
      }

      var outerStyle = {};
      if( useInterstitialFlow ) outerStyle = {paddingHorizontal:20};
      var setCardView =
        <View key={"stripecreditinput"+this.state.numberOfSuccessfulCardAdds}>
          {
            addCredit._hasCamera && CardIO != null ?
              <View style={{paddingBottom:4, marginTop:useInterstitialFlow ? 10 : 0}}>
                <ReUpIconButton key={addCredit.state.cameraView != null ? "credit-card" : "camera"} iconName={addCredit.state.cameraView != null ? "credit-card" : "camera"} type={1}
                  appManager={appManager}
                  style={{alignSelf:'flex-end'}}
                    onPress={() => {
                      if( addCredit.state.cameraView == null ) addCredit.showCardIO();
                      else addCredit.setState({cameraView:null});
                    }}
                    />
              </View>
            :
              <View />
          }
          {
            addCredit.state.cameraView !== 'undefined' && addCredit.state.cameraView != null ?
            addCredit.state.cameraView
            :
            <View style={outerStyle}>
              <View style={styles.cardNumberContainer}>
                {_newCardNumberField}
              </View>
              <View style={styles.dateContainer}>
                {_newCardMonthField}
                <View style={{alignSelf:'flex-end'}}><ReUpText appManager={appManager} style={styles.dateSlash}>/</ReUpText></View>
                {_newCardYearField}
                <View style={{flex:1}} />
                {_newCardSecurityField}
              </View>
              <View style={{flexDirection: 'row', marginHorizontal:8, alignSelf:'center'}}>
                {_newCardPostalCodeField}
              </View>
              {
                addCredit.state.showError && useInterstitialFlow ?
                  <ReUpText appManager={appManager} style={{color:'red', marginLeft:10, marginTop:10}}>
                    {errorMessage}
                  </ReUpText>
                : null
              }
              <ReUpButton style={[styles.choiceButton,{marginTop:20, marginBottom:10, marginLeft:10, marginRight:10}]}
                appManager={appManager}
                text={setCreditCardLabel}
                onPress={() => {
                  addCredit.setCardFinished();
                }}
                />
            </View>
          }

        </View>;

      return setCardView;
    }

    return <View key={"stripecreditinput"+this.state.numberOfSuccessfulCardAdds} />;    
  },

  _setCardShown : false,
  showSetCard : function()
  {
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
    if( useInterstitialFlow )
    {
      this.setState({cameraView:null});
      return;
    }
    this.props.appActions.hideAlert();
    this.setState({cameraView:null});
    return;

    var thisThing = this;
    var customAlert =
      <ScrollView bounces={true}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"} style={{margin:0,padding:2,paddingTop:10}}>
        {thisThing.getSetCardView()}
      </ScrollView>;

    this.props.appActions.setCustomAlertShown(true,customAlert);
  },

  showCardIO : function()
  {
    if( Platform.OS === 'ios')
    {
      var addCredit = this;
      var appManager = this.props.appManager;
      var locManager = this.props.appManager.getLocalizationManager();
      var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;

      var customAlert =
        <ScrollView bounces={true}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"} style={{margin:0}}>
          <CardIO
            style={
              {
                height:this.state.layout.height - 120,
                backgroundColor: 'black',
              }
            }
          />
        </ScrollView>;

      if( useInterstitialFlow )
      {
        this.setState({cameraView:customAlert});
      }
      else
      {
        this.props.appActions.setCustomAlertShown(true,customAlert);
      }
    }
    else
    {
      CardIO.show();
    }
  },

  submit : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var transactionConfirmTitle = locManager.localizedStringForKey("ADDCREDIT_CONFIRM_ALERT_TITLE");
    var transactionConfirmBody = locManager.localizedStringForKeyAndParams("ADDCREDIT_CONFIRM_ALERT_BODY", [this.amountText()]);
    var yesText = locManager.localizedStringForKey("YES_ALERT_BUTTON");
    var noText = locManager.localizedStringForKey("NO_ALERT_BUTTON");

    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");

    var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
    var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
    var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");

    var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
    var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
    appActions.showAlert(transactionConfirmTitle,transactionConfirmBody,[noText, yesText],[appActions.hideAlert, function()
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true, processingHUD);
      NetworkManager.submitPayment( appManager, thisThing.amount(), function(data)
      {
        appActions.setSpinnerShown(false);
        var user = appManager.currentUser();
        user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) + parseFloat(thisThing.amount());
        appManager.setCurrentUser(user, function()
        {
          appActions.showAlert(paymentSuccessTitle,paymentSuccessBody,[okayText],[function(){appActions.requestPop(false);appActions.hideAlert();}]);
        });
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showAlert(paymentFailTitle,paymentFailBody,[okayText]);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
      })
    }, appActions.hideAlert], function(){})
  },

  pullToRefreshView: function()
  {
    return this.refs.ptr
  },

  update: function()
  {

  },

  didUpdate: function(data)
  {
    var thisThing = this;
    this.props.appManager.getCurrentUser(function(user)
    {
      thisThing.setState({user:user, sources:thisThing.props.appManager.getPaymentInfo()});
    })
  },

  didSelectSourceIndex : function(index)
  {
    var method = this.state.sources[index];
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    if( method.isPrimary )
    {
      if( thisThing.props.extras.shouldPopAfterSelectingPaymentType )
      {
        setTimeout(function()
        {
          appActions.requestPop(true);
        }, 100)
      }
      return; // already primary
    }

    var refreshOrCardID = method.sourceType == 'pp' ? method.refreshToken : method.cardID;
    appActions.setSpinnerShown(true, appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD"));
    NetworkManager.setPrimaryPaymentMethod( this.props.appManager, refreshOrCardID, function(data)
    {
      thisThing._setCardShown = false;
      var paymentInfo = JSON.parse(data[0]);
      appManager.setPaymentInfo(data[0], function(user)
      {
        appActions.setSpinnerShown(false);
        thisThing.setState({sources:paymentInfo});
        if( thisThing.props.extras.shouldPopAfterSelectingPaymentType )
        {
          setTimeout(function()
          {
            appActions.requestPop(true);
          }, 100)
        }
      })
    }, function(data)
    {
      thisThing._setCardShown = false;
      appActions.setSpinnerShown(false);
      appActions.showLocalizedAlert("CHANGE_PAYMENT_METHOD_ERROR_ALERT_TITLE", "CHANGE_PAYMENT_METHOD_ERROR_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
        {
        appActions.hideAlert();
      }], function(){})
    }, function(data)
    {
      thisThing._setCardShown = false;
      appActions.setSpinnerShown(false);
      appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
    })
  },

  didSelectDeleteSourceIndex : function(index)
  {
    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    appActions.showLocalizedAlert("DELETE_PAYMENT_TYPE_ALERT_TITLE", "DELETE_PAYMENT_TYPE_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function()
      {
      appActions.hideAlert();
    }, function()
    {
      var method = thisThing.state.sources[index];
      var refreshOrCardID = method.sourceType == 'pp' ? method.refreshToken : method.cardID;
      appActions.hideAlert();
      appActions.setSpinnerShown(true, appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD"));
      NetworkManager.removePaymentMethod( thisThing.props.appManager, refreshOrCardID, function(data)
      {
        var paymentInfo = JSON.parse(data[0]);
        appManager.setPaymentInfo(data[0], function(user)
        {
          appActions.setSpinnerShown(false);
          thisThing.setState({sources:paymentInfo});
        })
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showLocalizedAlert("UNABLE_TO_REMOVE_PAYMENT_TYPE_ALERT_TITLE", "UNABLE_TO_REMOVE_PAYMENT_TYPE_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
          {
          appActions.hideAlert();
        }], function(){})
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
      })
    }], function(){})
  },

  addPayPal : function()
  {
    RNPayPalManager.showPayPal(this.props.appManager.currentUser()[ModelConstants.UserName], this.props.appManager.appName);
    // var sources = this.state.sources;
    // sources.push({isPayPal:true,userName:"kjregan10@gmail.com",isPrimary:false});
    // this.setState({sources:sources})
  },

  hasPayPal : function()
  {
    var hasPayPal = false;
    var sources = this.state.sources;
    for( var i = 0; i < sources.length; i++ )
    {
      if( sources[i].sourceType == 'pp' )
      {
        return true;
      }
    }
    return false;
  },

  render: function()
  {
    if( RNPayPalManager )
    {
      if( typeof this.state.payPalEnvironment !== 'undefined' )
      {
        RNPayPalManager.setPayPalSandbox(this.state.payPalEnvironment == "sandbox");
      }
      if( typeof this.state.payPalClientID !== 'undefined' )
      {
        RNPayPalManager.setPayPalClientID(this.state.payPalClientID,this.state.payPalClientID)
        RNPayPalManager.retrieveClientMetadataID();
      }
    }
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = this.state.user;
    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
    var credit = user != null ? parseFloat(user[ModelConstants.Credits]) : '';
    var maxCredit = MAX_CREDIT;
    var creditRatio = parseFloat(credit) / parseFloat(maxCredit);
    var flexPositive = Math.round(100 * Math.min(creditRatio,1));
    var useMinWidth = flexPositive > 0;
    var flexNegative = 100 - flexPositive;

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var howMuchStatement = locManager.localizedStringForKey("HOW_MUCH_LABEL");
    var setCreditCardButton = locManager.localizedStringForKey("ADD_CREDIT_CARD_BUTTON");

    var cardText = "";
    var cardType = user != null ? user[ModelConstants.CardType] : null;
    if( this.state.proposedCardNumber.length > 0 )
    {
      cardText = "**** **** **** " + this.state.proposedCardNumber.substring(this.state.proposedCardNumber.length-4,this.state.proposedCardNumber.length);
      cardType = cardTypeForNumber(this.state.proposedCardNumber);
    }
    else if( user != null && user[ModelConstants.LastFour] )
    {
      cardText = "**** **** **** " + user[ModelConstants.LastFour];
    }

    var priceChooserProps = {};
    if( lastSelectedAmount != null )
    {
      priceChooserProps.initialAmount = lastSelectedAmount;
    }

    var shouldShowOr = (this.state.hasStripe || this.state.hasBeanStream) && this.state.hasPayPal && !this.hasPayPal();

    return (
      <View style={[styles.container, {backgroundColor: generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }

        <ReUpScrollView ref="ptr" bounces={true} responder={this} style={{backgroundColor:generalColor}}>
          <ReUpText appManager={appManager} style={[styles.bodyText, {color:generalTitleColor}]}>
          {
            useInterstitialFlow ?
              locManager.localizedStringForKey("PAYMENT_TYPE_INSTRUCTION")
            :
              appManager.getFeatureForName("PaymentTypes").data.instructions
          }
          </ReUpText>
          <ShadowView layout={this.state.layout} appManager={appManager}/>
          {
            useInterstitialFlow && thisThing.getSetCardView()
          }
          {
            this.state.sources.map(function(source, index)
            {
              if( useInterstitialFlow ) return null;

              if( source.sourceType == 'pp' )
              {
                return (
                  <View style={{flexDirection:'column'}} key={"source"+index} >
                    <View style={{flexDirection:'row'}}>
                      <MKButton onPress={() => { thisThing.didSelectSourceIndex(index) }} rippleColor={primaryButtonColorLight} maskBorderRadius={0} style={[styles.oldCardContainer]}>
                        <View style={{flexDirection:'row'}}>
                          <MKRadioButton
                             checked={source.isPrimary}
                             fillColor={generalTitleColor}
                             borderOnColor={generalTitleColor}
                             borderOffColor={generalTitleColor}
                             rippleColor={primaryButtonColorLight}
                            />
                          <Image resizeMode={Image.resizeMode.contain} source={{uri:PlatformConstants.packagedResourcesDirectory + '/App/paypal.png'}} style={{backgroundColor:'transparent', height:30, width:110}} />
                          <View style={{flex:1, alignSelf:'center'}}>
                            <ReUpText appManager={appManager} style={{
                              fontStyle:'italic',
                              margin:4,
                              textAlign:'center',
                              opacity:.6,
                            }} numberOfLines={1}>{source.username}</ReUpText>
                          </View>
                        </View>
                      </MKButton>
                      <MKButton onPress={() => { thisThing.didSelectDeleteSourceIndex(index) }} maskBorderRadius={0} style={{marginRight:10,height:60, width:40, alignItems:'center', justifyContent:'center'}}>
                        <Icon style={styles.creditCardIcon} name={"times"} size={28} color={generalTitleColor} />
                      </MKButton>
                    </View>
                    <ShadowView layout={thisThing.state.layout} appManager={appManager}/>
                  </View>
                )
              }
              cardText = "**** **** **** " + source.last4;
              return (
                <View style={{flexDirection:'column'}} key={"source"+index} >
                  <View style={{flexDirection:'row', flex:1}}>
                    <MKButton onPress={() => { thisThing.didSelectSourceIndex(index) }} maskBorderRadius={0} key={"source"+index} rippleColor={primaryButtonColorLight} style={[styles.oldCardContainer]}>
                      <View style={{flexDirection:'row'}}>
                        <MKRadioButton
                           checked={source.isPrimary}
                           fillColor={generalTitleColor}
                           borderOnColor={generalTitleColor}
                           borderOffColor={generalTitleColor}
                           rippleColor={primaryButtonColorLight}
                          />
                        <Icon style={styles.creditCardIcon} maskBorderRadius={0} name={iconNameForCardType(source.cardType)} size={22} color={generalTitleColor} />
                        <ReUpText appManager={appManager} style={styles.creditCardText}>{cardText}</ReUpText>
                      </View>
                    </MKButton>
                    <MKButton onPress={() => { thisThing.didSelectDeleteSourceIndex(index) }} maskBorderRadius={0} rippleColor={primaryButtonColorLight} style={{padding:10,height:60, width:60, alignItems:'center', justifyContent:'center'}}>
                      <Icon style={styles.creditCardIcon} name={"times"} size={18} color={generalTitleColor} />
                    </MKButton>
                  </View>
                  <ShadowView layout={thisThing.state.layout} appManager={appManager}/>
                </View>
              )
            })
          }
          {
            this.state.hasStripe && !useInterstitialFlow ?
            <View style={{alignSelf:'stretch'}}>
            {thisThing.getSetCardView()}
            </View>
            :
            null
          }
          {
            this.state.hasBeanStream && !useInterstitialFlow ?
            <View style={{alignSelf:'stretch'}}>
            {thisThing.getSetCardView()}
            </View>
            :
            null
          }
          {
            shouldShowOr ?
            <ShadowView layout={this.state.layout} text={locManager.localizedStringForKey("OR_LABEL")} appManager={appManager}/>
            :
            null
          }
          {
            this.state.hasPayPal && !this.hasPayPal() ?
            <ReUpButton isSecondary={true} style={[styles.doneButton,{margin:10, marginTop:0}, (this.state.hasStripe || this.state.hasBeanStream) ? {} : {marginTop:10}]} appManager={appManager}
             text={""}
              onPress={() => {
                thisThing.addPayPal();
              }}
              >
              <Image resizeMode='contain' source={{uri:PlatformConstants.packagedResourcesDirectory + '/App/paypal.png'}} style={{backgroundColor:'transparent', height:26, width:110,flex:-1}}>
              </Image>
              </ReUpButton>
            :
            null
          }
        </ReUpScrollView>
        {
          this.state.shouldShowSpinner ?
          <ProgressOverlay ref="spinner" key="spinner" isVisible={this.state.shouldShowSpinner}
            spinnerText={this.state.spinnerText} spinnerBody={this.state.spinnerBody}
            layout={this.state.layout} appManager={appManager}>
          </ProgressOverlay>
          : null
        }
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },


  // meter

  meterContainer: {
    margin:10,
    height:20,
    borderRadius:10,
    flexDirection:'row',
  },
  meterFiller: {
    margin:1,
    height:18,
    borderRadius:9,
  },
  meterAntiFiller: {
    height:18,
    borderRadius:9,
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'left',
  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  // choices

  choicesContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:10,
    marginLeft:0,
    marginRight:0,
    height:60,
    alignItems:'center',
    justifyContent:'center'
  },
  choiceButton: {
    justifyContent:'center',
    flex:1,
    height:40,
  },

  // credit card
  oldCardContainer: {
    flexDirection:'row',
    flex:1,
    alignItems:'center',
    height:60,
    paddingLeft:10,
    alignSelf:'center',
    paddingRight:10,
    justifyContent:'center',
  },
  creditCardIcon: {
    width: 50,
    justifyContent: 'center',
    textAlign: 'center',
    margin:4,
    opacity:.6,
  },
  creditCardText: {
    fontStyle:'italic',
    margin:4,
    flex:1,
    textAlign:'center',
    opacity:.6,
  },
  creditCardEditButton: {
    padding:4,
  },
  creditCardEditButtonIcon: {
    fontSize:30,
    backgroundColor:'transparent'
  },

  // new card
  cardNumberContainer: {
    flexDirection: 'row',
    margin:8,
    marginTop:0,
    marginBottom:0
  },

  textField: {
    width:-1
  },

  dateContainer: {
    flexDirection: 'row',
    marginHorizontal:8,
  },
  dateField: {
    flex:-1,
    width:40,
    textAlign:'center',
  },
  cvvField: {
    flex:-1,
    width:80,
    textAlign:'center',
  },
  dateSlash: {
    paddingLeft:8,
    paddingRight:8,
    alignSelf:'flex-end',
    textAlign:'center',
  },

  doneButton: {
    justifyContent:'center',
    flex:1,
  },

  segmentContainer: {
    height:50,
    flex:1,
    alignSelf:'center'
  },
});

PaymentTypes.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var locManager = appManager.getLocalizationManager();
  var isLoggedIn = appManager.isLoggedIn();
  if( !isLoggedIn ) return [];
  if( typeof appManager.getFeatureForName("UseCredit") === 'undefined'
    && typeof appManager.getFeatureForName("AddPass") === 'undefined'
    && typeof appManager.getFeatureForName("SendGiftCard") === 'undefined' ) return [];

  var user = appManager.currentUser();
  var paymentInfo = appManager.getPaymentInfo();
  var hasPrimaryPaymentMethod = appManager.userHasPrimaryPaymentMethod();
  if( hasPrimaryPaymentMethod ) return [];

  var iconName = featureData.data.icon.replace("fa-", "")

  return [{
    didSelect : function() {appActions.requestFeatureName("PaymentTypes")},
    title : featureData.data.title,
    body1 : locManager.localizedStringForKey("PAYMENT_TYPE_TIP"),
    icon : featureData.data.icon.replace("fa-", ""),
    cardType : 0,
    sortOrder : 5
  }]
}


PaymentTypes.dataDependencies = ["Users", "Transactions"];

module.exports = PaymentTypes;



// WEBPACK FOOTER //
// ./src/PaymentTypes.js